var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import React, { isValidElement, useEffect, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';
import { SAIcons } from '../icon';
import { SAInputContainer } from '../input/input.component';
import { SATag } from '../tag/tag.component';
import { HiddenSelect } from './subcomponents/hiddenselect.component';
import { SASelectPopper } from './subcomponents/select-popper.component';
import { setReactInputValue } from './utils/changeEvent';
var StyledInputContainer = styled(SAInputContainer)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  select {\n    appearance: none;\n  }\n  .textLikeInput {\n    min-height: 50px;\n  }\n  .textLikeInputWrapper div.sa-input-faux-field {\n    flex-wrap: wrap;\n    height: auto;\n    margin: -5px 0;\n    gap: 5px;\n  }\n"], ["\n  select {\n    appearance: none;\n  }\n  .textLikeInput {\n    min-height: 50px;\n  }\n  .textLikeInputWrapper div.sa-input-faux-field {\n    flex-wrap: wrap;\n    height: auto;\n    margin: -5px 0;\n    gap: 5px;\n  }\n"])));
var OptionList = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  height: auto;\n  max-height: 50vh;\n  overflow: auto;\n  background: white;\n"], ["\n  height: auto;\n  max-height: 50vh;\n  overflow: auto;\n  background: white;\n"])));
export var CustomSelect = React.forwardRef(function (_a, ref) {
    var id = _a.id, label = _a.label, hint = _a.hint, children = _a.children, className = _a.className, error = _a.error, fullWidth = _a.fullWidth, iconLeft = _a.iconLeft, iconLeftLabel = _a.iconLeftLabel, iconLeftSize = _a.iconLeftSize, iconLeftColor = _a.iconLeftColor, onClickIconLeft = _a.onClickIconLeft, clickToRemove = _a.clickToRemove, onChange = _a.onChange, onBlur = _a.onBlur, onKeyDown = _a.onKeyDown, additionalProps = __rest(_a, ["id", "label", "hint", "children", "className", "error", "fullWidth", "iconLeft", "iconLeftLabel", "iconLeftSize", "iconLeftColor", "onClickIconLeft", "clickToRemove", "onChange", "onBlur", "onKeyDown"]);
    // useState
    var _b = useState(false), open = _b[0], setOpen = _b[1];
    var _c = useState(), highlighted = _c[0], setHighlighted = _c[1];
    // Refs
    var inputRef = useRef();
    useImperativeHandle(ref, function () { return inputRef.current; });
    var _d = useState(null), referenceElement = _d[0], setReferenceElement = _d[1];
    // Keeps track of options by ref
    var optionsRef = useRef([]);
    useEffect(function () {
        optionsRef.current = optionsRef.current.slice(0, React.Children.count(children));
    }, [React.Children.count(children)]);
    var _e = useState([]), selectedOptions = _e[0], setSelectedOptions = _e[1];
    var preventOnChange = useRef(false);
    // Adds selected options to selected options array for uncontrolled options
    useEffect(function () {
        setSelectedOptions(function (currentSelected) {
            var updatedSet = new Set(currentSelected);
            React.Children.forEach(children, function (child) {
                if (isValidElement(child) && typeof child.props.value === 'string' && Boolean(child.props.children)) {
                    var _a = child.props, value = _a.value, defaultSelected = _a.defaultSelected;
                    if (defaultSelected) {
                        updatedSet.add(value);
                    }
                }
            });
            var updatedArray = Array.from(updatedSet);
            return updatedArray;
        });
    }, []);
    // Adds selected options to selected options array for controlled options
    useEffect(function () {
        setSelectedOptions(function (currentSelected) {
            var updatedSet = new Set(currentSelected);
            React.Children.forEach(children, function (child) {
                if (isValidElement(child) && typeof child.props.value === 'string' && Boolean(child.props.children)) {
                    var _a = child.props, value = _a.value, selected = _a.selected;
                    if (selected) {
                        updatedSet.add(value);
                    }
                    else if (selected === false) {
                        updatedSet.delete(value);
                    }
                }
            });
            var updatedArray = Array.from(updatedSet);
            return updatedArray;
        });
    }, [children]);
    useEffect(function () {
        preventOnChange.current = true;
        setReactInputValue(inputRef.current, selectedOptions.join(','));
        preventOnChange.current = false;
    }, [selectedOptions]);
    // Adds target's value to value array if it doesn't already exist, removes it otherwise
    var handleSelection = function (selected, value) {
        var updatedSet = new Set(selectedOptions);
        if (selected) {
            updatedSet.add(value);
            var updatedArray = Array.from(updatedSet);
            setSelectedOptions(updatedArray);
            setReactInputValue(inputRef.current, updatedArray.join(','));
        }
        else {
            updatedSet.delete(value);
            var updatedArray = Array.from(updatedSet);
            setSelectedOptions(updatedArray);
            setReactInputValue(inputRef.current, updatedArray.join(','));
        }
    };
    // Adds value if it doesn't already exist, removes it otherwise
    var handleOptionClick = function (e) {
        // TODO: else case is not intended to be used
        // istanbul ignore else
        if (e.target instanceof HTMLDivElement && e.target.dataset.value) {
            var targetValue = e.target.dataset.value;
            // ariaSelected won't be set to 'true' until after the click event
            var selected = selectedOptions.includes(targetValue);
            handleSelection(!selected, targetValue);
            setHighlighted(e.target);
            e.target.focus();
        }
    };
    var findOption = function (e) {
        var keyArg = e.key.toLowerCase();
        var isLetter = keyArg >= 'a' && keyArg <= 'z';
        var isNumber = keyArg >= '0' && keyArg <= '9';
        if ((isLetter || isNumber) && keyArg.length === 1) {
            e.preventDefault();
            var optionsWithKey = optionsRef.current.filter(function (option) { var _a; return (_a = option === null || option === void 0 ? void 0 : option.textContent) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(keyArg); });
            var focusedOption = optionsRef.current.filter(function (option) { return document.activeElement === option; })[0];
            var optionToFocus = void 0;
            if (optionsWithKey.includes(focusedOption)) {
                var nextIndex = optionsWithKey.indexOf(focusedOption) + 1;
                if (optionsWithKey[nextIndex]) {
                    optionToFocus = optionsWithKey[nextIndex];
                }
                else {
                    optionToFocus = optionsWithKey[0];
                }
            }
            else {
                optionToFocus = optionsWithKey[0];
            }
            return optionToFocus;
        }
        return undefined;
    };
    // Borrowed from Material UI
    // https://github.com/mui/material-ui/blob/master/packages/mui-material/src/Select/SelectInput.js#L284
    // Support autofill.
    var handleChange = function (event) {
        var newValue = event.target.value.split(',');
        // eslint-disable-next-line no-param-reassign
        if (onChange && !preventOnChange.current) {
            var nativeEvent_1 = event.nativeEvent ||
                // TODO: figure out how to properly test this
                // istanbul ignore next
                event;
            // You can tell TypeScript the constructor has a construct signature by using new () => InstanceType
            // example: stackoverflow.com/questions/66206497/making-instance-via-constructor-property-of-another-instance-ts2351-this-expre
            var clonedEvent = new nativeEvent_1.constructor(nativeEvent_1.type, nativeEvent_1);
            Object.defineProperty(clonedEvent, 'target', {
                writable: true,
                value: { value: newValue },
            });
            onChange(clonedEvent);
        }
    };
    var removeLastValue = function () {
        var updatedArray = __spreadArrays(selectedOptions).slice(0, -1);
        setSelectedOptions(updatedArray);
        setReactInputValue(inputRef.current, updatedArray.join(','));
    };
    var handleKeyDownInput = function (e, onKeyDownProp) {
        // call function passed to SASelectOption as prop
        onKeyDownProp === null || onKeyDownProp === void 0 ? void 0 : onKeyDownProp(e);
        if (e.key === 'Backspace') {
            removeLastValue();
        }
        if (['Down', 'ArrowDown'].includes(e.key)) {
            e.preventDefault();
            // finds the first option in array
            var firstOption = optionsRef.current.findIndex(function (option) { return option; });
            var optionToFocus = optionsRef.current[firstOption];
            optionToFocus === null || optionToFocus === void 0 ? void 0 : optionToFocus.focus();
            setHighlighted(optionToFocus);
            return;
        }
        if (e.key.length !== 1) {
            return;
        }
        var optionWithCharacter = findOption(e);
        optionWithCharacter === null || optionWithCharacter === void 0 ? void 0 : optionWithCharacter.focus();
        setHighlighted(optionWithCharacter);
    };
    var handleKeyDownOption = function (e, onKeyDownProp) {
        // call function passed to SASelectOption as prop
        onKeyDownProp === null || onKeyDownProp === void 0 ? void 0 : onKeyDownProp(e);
        if (['Enter', 'Backspace', 'Up', 'ArrowUp', 'Down', 'ArrowDown'].includes(e.key)) {
            e.preventDefault();
        }
        if (e.key === 'Enter' && e.currentTarget.dataset.value) {
            var targetValue = e.currentTarget.dataset.value;
            // ariaSelected won't be set to 'true' until after the click event
            var selected = selectedOptions.includes(targetValue);
            handleSelection(!selected, targetValue);
            e.currentTarget.focus();
            setHighlighted(e.currentTarget);
            return;
        }
        if (e.key === 'Backspace') {
            removeLastValue();
        }
        // highlight previous option
        if (['Up', 'ArrowUp'].includes(e.key)) {
            var focusedIndex = optionsRef.current.findIndex(function (option) { return highlighted === option; });
            var optionToFocus = optionsRef.current[focusedIndex - 1] || optionsRef.current[optionsRef.current.length - 1];
            optionToFocus === null || optionToFocus === void 0 ? void 0 : optionToFocus.focus();
            setHighlighted(optionToFocus);
            return;
        }
        // highlight next option
        if (['Down', 'ArrowDown'].includes(e.key)) {
            var focusedIndex = optionsRef.current.findIndex(function (option) { return highlighted === option; });
            var firstOption = optionsRef.current.findIndex(function (option) { return option; });
            var optionToFocus = optionsRef.current[focusedIndex + 1] || optionsRef.current[firstOption];
            optionToFocus === null || optionToFocus === void 0 ? void 0 : optionToFocus.focus();
            setHighlighted(optionToFocus);
            return;
        }
        var optionWithCharacter = findOption(e);
        optionWithCharacter === null || optionWithCharacter === void 0 ? void 0 : optionWithCharacter.focus();
        setHighlighted(optionWithCharacter);
    };
    // Handle removing items by clicking on tag
    var handleRemove = function (item) {
        var updatedSet = new Set(selectedOptions);
        updatedSet.delete(item);
        var updatedArray = Array.from(updatedSet);
        setSelectedOptions(updatedArray);
        setReactInputValue(inputRef.current, updatedArray.join(','));
        inputRef.current.focus();
    };
    var handleBlur = function (e) {
        var isOptionItem = e.relatedTarget instanceof HTMLDivElement && optionsRef.current.includes(e.relatedTarget);
        var isInputRef = e.relatedTarget === inputRef.current;
        if (isOptionItem === false && isInputRef === false) {
            onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
            setOpen(false);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(StyledInputContainer, __assign({ role: "button", id: id, label: { label: label, method: 'labelledBy' }, hint: hint, error: error, className: "saSelectWrapper " + (className || ''), icon: SAIcons.chevronDownBold, fullWidth: fullWidth, iconLeft: iconLeft, iconLeftLabel: iconLeftLabel, iconLeftSize: iconLeftSize, iconLeftColor: iconLeftColor, onClickIconLeft: onClickIconLeft, onKeyDown: function (e) { return handleKeyDownInput(e, onKeyDown); }, onFocus: function () { return setOpen(true); }, onBlur: handleBlur, 
            // TODO: allow override
            tabIndex: 0, type: "text" }, additionalProps),
            React.createElement("div", { style: { width: '100%' }, className: "sa-input-faux-field", ref: setReferenceElement },
                selectedOptions.map(function (item) { return (React.createElement(SATag, { key: item, variant: "standard", label: item, closeable: clickToRemove, onClose: function () { return handleRemove(item); } })); }),
                React.createElement(HiddenSelect, { ref: inputRef, onChange: handleChange }))),
        React.createElement(SASelectPopper, { open: open, referenceElement: referenceElement },
            React.createElement(OptionList, { "aria-labelledby": id + "-label", role: "listbox" }, React.Children.map(children, function (child, index) {
                if (isValidElement(child) && typeof child.props.value === 'string' && Boolean(child.props.children)) {
                    var _a = child.props, value = _a.value, onKeyDownProp_1 = _a.onKeyDown;
                    var newProps = {
                        onClick: handleOptionClick,
                        onKeyDown: function (e) { return handleKeyDownOption(e, onKeyDownProp_1); },
                        onBlur: handleBlur,
                        selected: selectedOptions.includes(value),
                        className: "" + (highlighted && highlighted === optionsRef.current[index] ? 'SASelectOptionHighlighted' : ''),
                        ref: function (el) { return (optionsRef.current[index] = el); },
                    };
                    return React.cloneElement(child, newProps);
                }
                return child;
            })))));
});
export var SASelect = React.forwardRef(function (_a, ref) {
    var options = _a.options, defaultValue = _a.defaultValue, id = _a.id, label = _a.label, hint = _a.hint, className = _a.className, error = _a.error, fullWidth = _a.fullWidth, iconLeft = _a.iconLeft, iconLeftLabel = _a.iconLeftLabel, iconLeftSize = _a.iconLeftSize, iconLeftColor = _a.iconLeftColor, onClickIconLeft = _a.onClickIconLeft, clickToRemove = _a.clickToRemove, multiple = _a.multiple, children = _a.children, onChange = _a.onChange, variant = _a.variant, onBlur = _a.onBlur, additionalProps = __rest(_a, ["options", "defaultValue", "id", "label", "hint", "className", "error", "fullWidth", "iconLeft", "iconLeftLabel", "iconLeftSize", "iconLeftColor", "onClickIconLeft", "clickToRemove", "multiple", "children", "onChange", "variant", "onBlur"]);
    return multiple && variant === 'checkbox' && children ? (React.createElement(CustomSelect, __assign({ id: id, label: label, hint: hint, error: error, className: className, icon: SAIcons.chevronDownBold, fullWidth: fullWidth, iconLeft: iconLeft, iconLeftLabel: iconLeftLabel, iconLeftSize: iconLeftSize, iconLeftColor: iconLeftColor, onClickIconLeft: onClickIconLeft, clickToRemove: clickToRemove, ref: ref, onChange: onChange, onBlur: onBlur }, additionalProps), children)) : (React.createElement(StyledInputContainer, { id: id, label: label, hint: hint, error: error, className: "saSelectWrapper " + (className || ''), icon: SAIcons.chevronDownBold, fullWidth: fullWidth, iconLeft: iconLeft, iconLeftLabel: iconLeftLabel, iconLeftSize: iconLeftSize, iconLeftColor: iconLeftColor, onClickIconLeft: onClickIconLeft },
        React.createElement("select", __assign({ defaultValue: defaultValue, ref: ref, onChange: onChange, onBlur: onBlur }, additionalProps, { multiple: multiple }), options === null || options === void 0 ? void 0 : options.map(function (item) {
            return (React.createElement("option", { key: "" + item.label + item.value, label: item.label }, item.value));
        }))));
});
SASelect.defaultProps = {
    defaultValue: undefined,
};
var templateObject_1, templateObject_2;
//# sourceMappingURL=select.component.js.map